import { z } from "zod";
import { COMPANY_VISIBILITY } from "../constnats/companyConstants";

export const companyInfoSchema = z.object({
    id: z.number(),
    name: z.string(),
    description: z.string(),
    currency: z.string(),
    internalDocLink: z.string().nullable(),
    nextReportingDate: z.string().nullable(),
    nextReportingDateConfirmedOn: z.string().nullable(),
    nextReportingPeriod: z.string().nullable(),
    isin: z.string(),
    ticker: z.string(),
    suspended: z.boolean(),
    visibility: z.nativeEnum(COMPANY_VISIBILITY),
    ownerId: z.number(),
});

export type CompanyInfoType = z.infer<typeof companyInfoSchema>;
